import { render, staticRenderFns } from "./pencarian-dana.vue?vue&type=template&id=96b004d0&"
import script from "./pencarian-dana.vue?vue&type=script&lang=js&"
export * from "./pencarian-dana.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports